<template lang="pug">
  include /mixins
  +b.modal-wrapper
    +e.title.P {{ info.title }}
    +e.steps(v-if="!info.simple")
      +b.t-steps-line
        +e.item.is-active
        +e.item.is-active
    +e.content
      +b.VALIDATION-OBSERVER(
        ref="validator",
        v-slot="{ valid }",
        tag="form",
      )
        ui-loader(v-if='isLoad')
        +b.form-fields
          +b.g-row.--space_2xl.--appearance_spaced
            +b.g-cell.g-cols--12(
              v-for='{ rules, name, label, tag, classname,events, errorClasses, mask, type, props, cols, getRules } in fields'
              :class='cols || "g-cols--12"'
            )
              tag(
                :tag='tag || "d-control-input"'
                :rules="rules || getRules && getRules()",
                :input-label='label'
                v-model='form[name]',
                :ref='name'
                v-bind='props'
                v-on='events'
                @input='$emit("update", form)'
                :name='name'
                :type='type || "text"'
                :key='name'
                :class='classname',
                :error-classes='errorClasses'
              )
            +b.g-cell.g-cols--12
              +b.ds-caption.--size_sm.--medium.--color_black.P {{ _("Нажимая кнопку “Отправить вы соглашаетесь с") }} &nbsp;
                +b.tt-link--inline.--styling_default.--black.A.ds-caption--size_sm.--medium(
                  :href="offer"
                  target="_blank"
                ) {{ _("политикой конфиденциальности") }}
                span &nbsp; {{ _("и") }} &nbsp;
                +b.tt-link--inline.--styling_default.--black.A.ds-caption--size_sm.--medium(
                  :href="rules"
                  target="_blank"
                ) {{ _("правилами пользования TOTIS Pharma") }}
            +b.g-cell.g-cols--12
              +b.ds-panel.--space_md
                +e.element.--offset_top
                  +b.g-row--justify_center
                    +b.g-cell.g-cols--12.--4-xl
                      +b.tt-button.BUTTON(
                        type='submit'
                        :disabled='isLoad',
                        @click.prevent='prepareData'
                      )
                        +e.title.P {{ _("Надiслати") }}
</template>

<script>
import FormMixin, { defaultValidatorErrorsParser } from '@app/Forms/FormMixin'
import { createFeedback } from '@api/feedback.service'

import SuccessForm from '@app/Blog/PostFeedbackSuccess'

export default {
  name: 'PostFeedbackForm',

  mixins: [FormMixin],

  props: {
    info: {
      type: Object,
    },
  },

  data() {
    return {
      isLoad: false,
      offer: window.offer,
      rules: window.rules,
      fields: [
        {
          name: 'name',
          label: this._('Имя'),
          rules: 'required',
        },
        {
          name: 'last_name',
          label: this._('Фамилия'),
          rules: 'required',
        },
        {
          name: 'phone',
          label: this._('Номер телефона'),
          rules: 'required|phone',
          tag: 'phone-input',
        },
        {
          name: 'email',
          label: this._('Эл. почта'),
          rules: 'required',
        },
        {
          name: 'message',
          label: this._('Ваш ответ'),
          classname: 'is-textarea',
          tag: 'd-control-textarea',
          rules: 'required',
          props: {
            rows: 4,
            class: 'is-textarea',
          },
        },
      ],
      form: {
        name: window.request_name,
        last_name: window.request_lastname,
        email: window.request_email || '',
        phone: window.request_phone,
        message: '',
        source: window.location.href,
      },
      non_field_errors: '',
    }
  },

  methods: {
    async prepareData(valid) {
      const isValid = (await this.$refs.validator.validate())

      if (!isValid) return

      const data = JSON.parse(JSON.stringify(this.form))

      data.subject = this.info.subject

      this.submit(isValid, data);
    },

    send(data) {
      return createFeedback.execute({}, data).then(() => {
        this.$modal.show(SuccessForm, {
          message: this.info.message,
        }, {
          height: 'auto',
          classes: ['defaultModal post-modal'],
          adaptive: true,
          scrollable: true,
        })

        if (this.info.pr) {
          this.info.pr(true)
        }

        this.$emit('close')
      })
    },

    updateValidator(errors) {
      const parsed = defaultValidatorErrorsParser(errors);

      this.non_field_errors = parsed.non_field_errors;

      this.$refs.validator.setErrors(parsed);
    },
  },
};
</script>
